"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drive = void 0;
var progress_1 = require("../common/progress");
var promise_1 = require("../utils/promise");
var object_1 = require("../common/object");
var contentPartialTransferrer_1 = require("../common/contentPartialTransferrer");
var Drive = /** @class */ (function (_super) {
    __extends(Drive, _super);
    function Drive(settings, localContentFactory, remoteContentFactory) {
        var _this = _super.call(this, "Drive") || this;
        _this.settings = settings;
        _this.localContentFactory = localContentFactory;
        _this.remoteContentFactory = remoteContentFactory;
        return _this;
    }
    Drive.prototype.getMetadata = function (contentUrl) {
        var remoteContent = this.remoteContentFactory.createByUrl(contentUrl);
        return (0, promise_1.retry)(function () { return remoteContent.getMetadata(); }, this.settings.requestsMaxAttempts, null, this.settings.retryDelay);
    };
    Drive.prototype.download = function (contentUrl, sink, options, token, p) {
        var _this = this;
        var localContent = this.localContentFactory.create(sink);
        var remoteContent = this.remoteContentFactory.createByUrl(contentUrl);
        options = options || {};
        p = p || new progress_1.Progress("drive download");
        var sourceOffset = options.offset || 0;
        if (options.count === 0) {
            this.log.warn("Suspicious argument: drive.download's options.count is set to zero.");
            return (0, promise_1.promiseResolve)({
                content: localContent,
                mimeType: null,
            });
        }
        var firstTakeCount = options.count && options.count < this.settings.chunkSizeBytes
            ? options.count
            : this.settings.chunkSizeBytes;
        var promise = (0, promise_1.retry)(function () {
            return remoteContent.read(localContent, sourceOffset, 0, firstTakeCount, token);
        }, this.settings.requestsMaxAttempts, null, this.settings.retryDelay)
            .then(function (result) {
            var totalSize = options.count || result.total;
            var downloadedBytes = result.to - result.from + 1;
            var downloadedOnFirstRequest = downloadedBytes === totalSize;
            if (downloadedOnFirstRequest) {
                p.complete();
                return localContent;
            }
            p.child("first", 1).complete();
            var config = _this.getTransferrerConfig();
            var currentSourceOffset = sourceOffset + firstTakeCount;
            return contentPartialTransferrer_1.ContentPartialTransferrer.fromRemote(remoteContent, localContent, totalSize, currentSourceOffset, firstTakeCount, config, null, token, p.child("rest", totalSize / currentSourceOffset));
        })
            .then(function (content) {
            return ({ content: content, mimeType: "unknown" });
        }); //TODO mimeType
        return this.log.operation("download file", promise, {
            contentUrl: contentUrl,
            localContent: localContent,
        });
    };
    Drive.prototype.upload = function (content, options, token, p) {
        var _this = this;
        var localContent = this.localContentFactory.create(content);
        var promise = (0, promise_1.promiseResolve)()
            .then(function () {
            if (options && options.path) {
                var path = options.path;
                return (0, promise_1.promiseResolve)(_this.remoteContentFactory.createByPath(path));
            }
            else {
                return localContent.md5().then(function (md5String) {
                    return _this.remoteContentFactory.createByHash(md5String, options);
                });
            }
        })
            .then(function (remoteContent) {
            return _this.selectStrategyAndUpload(localContent, remoteContent, options, token, p);
        });
        return this.log.operation("upload file", promise, {
            localContent: localContent,
            options: options,
        });
    };
    Drive.prototype.selectStrategyAndUpload = function (localContent, remoteContent, options, token, p) {
        var _this = this;
        return localContent.size().then(function (size) {
            if (size < _this.settings.partialUploadSizeThresholdBytes) {
                return _this.uploadInOnePiece(localContent, remoteContent, options, token, p);
            }
            else {
                return _this.uploadPieceByPiece(localContent, remoteContent, size, options, token, p);
            }
        });
    };
    Drive.prototype.uploadInOnePiece = function (content, remoteContent, uploadOptions, token, p) {
        return remoteContent.writeAll(content, remoteContent.name(), uploadOptions, token, p);
    };
    Drive.prototype.uploadPieceByPiece = function (content, remoteContent, size, options, token, p) {
        var _this = this;
        return (0, promise_1.retry)(function () { return remoteContent.initPartialWrite(remoteContent.name(), size, options); }, this.settings.requestsMaxAttempts, null, this.settings.retryDelay)
            .then(function (initResult) {
            if (initResult.conflict) {
                p && p.complete();
                return;
            }
            var currentOffset = initResult.currentOffset;
            var config = _this.getTransferrerConfig();
            return contentPartialTransferrer_1.ContentPartialTransferrer.toRemote(content, remoteContent, size, currentOffset, currentOffset, config, "DriveTransferrer", token, p);
        })
            .then(function () {
            return {
                name: remoteContent.name(),
                url: remoteContent.url(),
            };
        });
    };
    Drive.prototype.getTransferrerConfig = function () {
        return {
            chunkSize: this.settings.chunkSizeBytes,
            maxAttempts: this.settings.requestsMaxAttempts,
            retryDelay: this.settings.retryDelay,
        };
    };
    return Drive;
}(object_1.BaseObject));
exports.Drive = Drive;
